import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { CustomerOrder } from 'entities/customer_order'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const CustomerOrderColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'customer_order_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: '作成日', th: true, width: 120, form: form, orderAttr: 'customer_order_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: '注文個数', th: true, width: 120, form: form, align: 'center' },
            {
                name: '顧客コード',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'customer_order_updated_at',
                searchType: { name: 'updated_at', type: 'multiple_text' },
            },
            {
                name: '商品コード',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'customer_order_item_code',
                searchType: { name: 'item_code', type: 'multiple_text' },
            },
            {
                name: '購入者',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'customer_order_name',
                searchType: { name: 'name', type: 'text' },
            },
            {
                name: '購入者(カナ)',
                th: true,
                width: 120,
                form: form,
                orderAttr: 'customer_order_name_kana',
                searchType: { name: 'name_kana', type: 'text' },
            },
            { name: '電話番号', th: true, width: 120, form: form, orderAttr: 'customer_order_tel', searchType: { name: 'tel', type: 'text' } },
            { name: '注文日', th: true, width: 120, form: form, orderAttr: 'customer_order_ordered_date', searchType: { name: 'ordered_date', type: 'date' } },
        ],
    }
}

export type CustomerOrderTableDataProps = {
    customerOrder?: CustomerOrder
    displaySetting: DisplaySetting
}

export const CustomerOrderTableData = ({ customerOrder, displaySetting }: CustomerOrderTableDataProps): JSX.Element => {
    if (!customerOrder) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{customerOrder.id}</TableCell>
                <TableCell>{toDateText(customerOrder.createdAt)}</TableCell>
                <TableCell align="center">{customerOrder.requestForms?.length ?? 0}</TableCell>
                <TableCell>{customerOrder.customerCode}</TableCell>
                <TableCell>{customerOrder.itemCode}</TableCell>
                <TableCell>{customerOrder.name}</TableCell>
                <TableCell>{customerOrder.nameKana}</TableCell>
                <TableCell>{customerOrder.tel}</TableCell>
                <TableCell>{customerOrder.orderedDate}</TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
